import { Stack } from 'expo-router';
import React from 'react';
import DesktopNavigation from 'shared/components/vxl/navigation/DesktopNavigation/DesktopNavigation';
import { useShouldShowDesktopNavigation } from 'shared/hooks/useShouldShowDesktopNavigation';

function ConfirmYourAddressLayoutWeb() {
  const shouldShowDesktopNavigation = useShouldShowDesktopNavigation();

  return shouldShowDesktopNavigation ? (
    <DesktopNavigation>
      <Stack screenOptions={{ headerShown: false }} />
    </DesktopNavigation>
  ) : (
    <Stack screenOptions={{ headerShown: false }} />
  );
}

export default ConfirmYourAddressLayoutWeb;
